import axiosInstance from './Api';

export default {

  getUserProfile: () => axiosInstance().get(`/api/admin/user-profile/`)

}



// WEBPACK FOOTER //
// ./src/services/UserProfileServices.js